import { Button } from 'shared/ui/Button'
import cls from './ErrorScreen.module.scss'

export const ErrorScreen = (props) => {
    const {
        actionText,
        description,
        footer,
        image,
        imageAlt,
        onAction,
        title,
    } = props

    return (
        <div className={`${cls.ErrorScreen} normal`}>
            <main className={cls.Content}>
                <img className={cls.Image} src={image} alt={imageAlt} />
                <h1 className={cls.Title}>{title}</h1>
                {description ? (
                    <p className={cls.Description}>{description}</p>
                ) : null}
                <Button
                    ariaLabel={actionText}
                    className={cls.Button}
                    onClick={onAction}
                    text={actionText}
                />
                {footer ? <div className={cls.Footer}>{footer}</div> : null}
            </main>
        </div>
    )
}
